import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type ProcessStepTextAndImageRowProps = {
  icon: string;
};

const ProcessStepTextAndImageRow: React.FC<ProcessStepTextAndImageRowProps> = ({
  icon,
  children,
}) => {
  const { t } = useTranslation('Matching+Process', { i18n });

  return (
    <div className="ProcessStepTextAndImageRow">
      <div className="ProcessStepTextAndImageRow__content">{children}</div>
      <div className="ProcessStepTextAndImageRow__image">
        <img src={icon} alt={t('SSCandidate_Matching_Process_Alt_Row_Icon')} />
      </div>
    </div>
  );
};

export default ProcessStepTextAndImageRow;
